import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaUser, FaBell, FaLock } from "react-icons/fa";
import { url } from "../constants/url";
import { useNavigate } from "react-router-dom";

const SkeletonCard = () => (
  <div className="animate-pulse border rounded-lg p-4 shadow-md flex flex-col space-y-2 bg-gray-50">
    <div className="flex justify-between items-center">
      <div className="bg-gray-300 rounded-full w-10 h-10" />
      <div className="bg-gray-300 h-5 w-10 rounded" />
    </div>
    <div className="bg-gray-300 h-3 w-3/4 rounded" />
    <div className="bg-gray-300 h-3 w-1/2 rounded" />
    <div className="space-y-3">
      <div className="bg-gray-200 rounded-lg h-14 w-full" />
      <div className="bg-gray-200 rounded-lg h-14 w-full" />
    </div>
  </div>
);

const Home = () => {
  const [dashboard, setDashboard] = useState(null);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchDashboard = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(url + "/api/admin/dashboard-summary", {
          headers: { Authorization: `Bearer ${token}` }
        });
        setDashboard(response.data);
      } catch (error) {
        // on 401, clear auth and redirect
        if (error.response?.status === 401) {
          localStorage.clear();
          navigate("/login");
        } else {
          console.error("Failed to load dashboard", error);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchDashboard();
  }, []);

  if (loading || !dashboard) {
    return (
      <div className="h-screen overflow-hidden bg-white p-4 grid grid-cols-1 md:grid-cols-3 gap-4">
        <SkeletonCard />
        <SkeletonCard />
        <SkeletonCard />
      </div>
    );
  }

  return (
    <div className=" space-y-4 bg-white p-4 grid grid-rows-2 ">
      {/* First Row: Professionals (Full Width) */}
      <div className="row-span-1">
        <div className="border rounded-lg p-4 shadow h-52 flex flex-col justify-between bg-gray-50">
          <div className="flex justify-between items-center">
            <div className="bg-gray-200 rounded-full p-2">
              <FaUser className="text-gray-600 text-base" />
            </div>
            <p className="text-xl font-bold">{dashboard.professionals.total}</p>
          </div>
          <h3 className="font-semibold">Professionals</h3>
          <h4 className="text-green-500 font-medium text-sm">
            {dashboard.professionals.newThisMonth} New This Month
          </h4>
        </div>
      </div>

      {/* Second Row: Private Suites & Salons */}
      <div className="grid grid-cols-2 gap-4 row-span-1">
        {/* Private Suites */}
        <div className="border rounded-lg p-4 shadow h-full flex flex-col justify-between bg-gray-50">
          <div className="flex justify-between items-center">
            <div className="bg-gray-200 rounded-full p-2">
              <FaUser className="text-gray-600 text-base" />
            </div>
            <p className="text-xl font-bold">{dashboard.privateSuites.total}</p>
          </div>
          <h3 className="font-semibold">Private Suites</h3>
          <h4 className="text-green-500 font-medium text-sm">
            {dashboard.privateSuites.newThisMonth} New This Month
          </h4>
          <div className="grid grid-cols-2 gap-2 pt-1">
            <div className="border rounded p-2 bg-white flex flex-col items-center">
              <FaUser className="text-gray-600 mb-1 text-sm" />
              <span>Subscribed</span>
              <span>{dashboard.privateSuites.subscribed}</span>
            </div>
            <div className="border rounded p-2 bg-white flex flex-col items-center">
              <FaUser className="text-gray-600 mb-1 text-sm" />
              <span>Free</span>
              <span>{dashboard.privateSuites.free}</span>
            </div>
          </div>
        </div>

        {/* Salons */}
        <div className="border rounded-lg p-4 shadow h-full flex flex-col justify-between bg-gray-50">
          <div className="flex justify-between items-center">
            <div className="bg-gray-200 rounded-full p-2">
              <FaUser className="text-gray-600 text-base" />
            </div>
            <p className="text-xl font-bold">{dashboard.salons.total}</p>
          </div>
          <h3 className="font-semibold">Salons</h3>
          <h4 className="text-green-500 font-medium text-sm">
            {dashboard.salons.newThisMonth} New This Month
          </h4>
          <div className="grid grid-cols-2 gap-2 pt-1">
            <div className="border rounded p-2 bg-white flex flex-col items-center">
              <FaUser className="text-gray-600 mb-1 text-sm" />
              <span>Subscribed</span>
              <span>{dashboard.salons.subscribed}</span>
            </div>
            <div className="border rounded p-2 bg-white flex flex-col items-center">
              <FaUser className="text-gray-600 mb-1 text-sm" />
              <span>Free</span>
              <span>{dashboard.salons.free}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
